import { CodeDescriptionDto } from "api/api.typing";
import { TaskBase } from "pages/project/common/taskBase.typing";

export const OFFER_LIST_TYPE: Record<OfferListType, OfferListType> = {
  pending: "pending",
  accepted: "accepted",
};

export type OfferListType = "pending" | "accepted";
export type OfferActionType = "decline" | "accept";

export type OfferListRouteParam = { type: OfferListType; id: string; action: OfferActionType };

export interface Offer extends Omit<TaskBase, "id" | "unit" | "secondUnit"> {
  id: string; // convert to string, easier to manage in react-router
  taskId: string;
  status: OfferStatus;
  searchFields: string;
  unit: string;
  secondUnit: string;
  useTep: boolean;
  relatedTaskId: number | null;
}

export interface RejectReason {
  id: string;
  label: string;
}

export enum OfferStatus {
  Sent = 1,
  Accepted = 2,
  AcceptedOnBehalf = 4,
}

export const mapToListType = (status: OfferStatus): OfferListType | null => {
  if (status === OfferStatus.Sent) {
    return OFFER_LIST_TYPE.pending;
  }
  if ([OfferStatus.Accepted, OfferStatus.AcceptedOnBehalf].includes(status)) {
    return OFFER_LIST_TYPE.accepted;
  }
  return null;
};

export interface AcceptOrRejectMultipleOffersResponseDto {
  validationErrors: CodeDescriptionDto[];
  errors: CodeDescriptionDto[];
}
